"use client";

import { ErrorBoundary } from "@/app/components/shared/error-boundary";
import type { Locale } from "@/domain";
import Script from "next/script";

import * as styles from "./promotional-progress-bar-element.module.scss";

export interface PromotionalProgressBarElementProps {
	locale: Locale;
	currency?: string;
}

export function PromotionalProgressBarElement({
	locale,
	currency
}: PromotionalProgressBarElementProps): JSX.Element {
	return (
		<ErrorBoundary componentId="promotional_progress_bar_element">
			<Script src="/consumer-web-elements.js" strategy="lazyOnload" />
			<div
				className={styles["wrapper"]}
				data-component="PromotionalProgressBarElement"
			>
				<promotion-bar
					locale={locale}
					{...(currency ? { currency } : {})}
				/>
			</div>
		</ErrorBoundary>
	);
}
